import React, { useState, useEffect } from "react";
import { handleresend, handleverify } from "../../services/apicall.tsx";
import { useUserContext, Statescontex } from "../../context/index.js";
import { Input, Button, Form, Typography } from "antd";
import { colors } from "../../devdata/constants/themes";
import { useNavigate } from "react-router-dom";
import expandedLogo from "../../devdata/icons/marketpulse.svg";

const { Text } = Typography;

const collapsedLogo = require("../../devdata/icons/logo.png");

const Verify = () => {
  const { setErrorshow, setErrorMessage } = Statescontex();
  const { userToken, updateState, userdetails, isloggedin, setlogin } =
    useUserContext();
  const navigate = useNavigate();

  const [otp, setOtp] = useState(new Array(6).fill(""));
  const [isResendDisabled, setIsResendDisabled] = useState(false);
  const [timer, setTimer] = useState(30);
  const [loading, setLoading] = useState(false);

  const handleChange = (value, index) => {
    if (!/^[0-9]*$/.test(value)) return;

    const newOtp = [...otp];
    newOtp[index] = value;

    setOtp(newOtp);

    if (value && index < 5) {
      const nextInput = document.getElementById(`otp-${index + 1}`);
      if (nextInput) nextInput.focus();
    }
  };

  // 🆕 Handle paste event
  const handlePaste = (e) => {
    e.preventDefault();
    const pastedData = e.clipboardData.getData("text").trim();

    if (!/^\d{6}$/.test(pastedData)) return; // Validate full 6-digit OTP

    setOtp(pastedData.split("")); // Fill all inputs with pasted OTP

    const lastInput = document.getElementById(`otp-5`);
    if (lastInput) lastInput.focus(); // Move focus to the last input
  };

  const handleVerify = () => {
    const otpCode = otp.join("");
    if (otpCode.length !== 6) {
      setErrorMessage("h_Please enter a 6-digit OTP.");
      setErrorshow(true);
      return;
    }
    handleverify(
      setLoading,
      userToken,
      otpCode,
      userdetails,
      window.location,
      updateState,
      setErrorMessage,
      setErrorshow,
      setlogin
    );
  };

  const handleResend = () => {
    setIsResendDisabled(true);
    setTimer(30);
    sessionStorage.setItem("resendCount", "2");

    handleresend(setLoading, userToken, setErrorMessage, setErrorshow);

    const countdown = setInterval(() => {
      setTimer((prev) => {
        if (prev <= 1) {
          clearInterval(countdown);
          setIsResendDisabled(false);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
  };
  useEffect(() => {
    const scount = sessionStorage.getItem("resendCount")
    if (scount !== "2") {
      console.log("Resending Otp");
      handleResend();
    }
  }, [isloggedin]);

  return (
    <div className="flex min-h-screen sm:h-auto flex-col sm:flex-row">
      {/* Full height screen on desktop, auto on mobile, flex direction changes on small screens */}
      <div className="sm:w-1/2 relative h-1/2 sm:h-screen bg-gradient-to-br from-[#005C32] to-[#11CD77] hidden sm:block">
        <img
          alt="bars"
          src={require("../../devdata/assets/bars.png")}
          className="h-full"
        />

        {/* Green left/top section, hidden on mobile, visible on larger screens */}
      </div>
      <div className="sm:w-1/2 min-h-screen bg-darkMode-background flex flex-col justify-center items-center p-6 sm:p-8">
        {/* Dark right/bottom section, flex column layout, padding adjusted for small screens */}
        <div className="absolute top-4 sm:top-8 left-6 sm:left-auto">
          {/* Logo at top, adjusted top and left for small screens */}
          <img
            src={expandedLogo}
            alt="Expanded Logo"
            className="w-24 sm:w-36 h-auto mb-6 sm:mb-10" // Adjusted logo width and margin bottom for small screens
          />
        </div>
        <div className="w-full sm:max-w-md flex flex-col justify-center items-center">
          <p className="text-darkMode-subText mb-4 sm:mb-6 text-sm text-center">
            {/* Adjusted paragraph margin bottom for small screens */}
            Confirmation OTP has been sent to {userdetails?.username}
          </p>
          <div className="text-darkMode-text w-full sm:w-2/3">
            {/* White form container, full width on small screens, 2/3 on larger */}
            <Form layout="vertical">
              <Form.Item
                label={
                  <label style={{ color: colors.darkMode.text }}>
                    Enter OTP
                  </label>
                }
              >
                <div className="flex justify-center gap-3 sm:gap-4">
                  {/* Adjusted gap between OTP inputs for small screens */}
                  {otp.map((digit, index) => (
                    <Input
                      key={index}
                      id={`otp-${index}`}
                      maxLength={1}
                      value={digit}
                      onChange={(e) => handleChange(e.target.value, index)}
                      onPaste={index === 0 ? handlePaste : undefined} // Paste only in the first box
                      className="w-10 h-10 sm:w-12 sm:h-12 text-center text-xl rounded-xl focus:!ring-darkMode-greenDarker focus:ring-2 focus:!shadow-none"
                      style={{
                        borderColor: "#D1D5DB",
                        backgroundColor: "white",
                        color: "black",
                      }}
                    />
                  ))}
                </div>
              </Form.Item>

              <Form.Item>
                <button
                  type="primary"
                  htmltype="submit"
                  className="w-full rounded-xl py-2 sm:py-3" // Adjusted button padding for small screens
                  onClick={handleVerify}
                  style={{
                    backgroundColor: colors.darkMode.green,
                  }}
                >
                  <span className="text-darkMode-layer3 text-base sm:text-xl font-semibold">
                    {/* Adjusted button text size for small screens */}
                    Verify
                  </span>
                </button>
              </Form.Item>

              <Form.Item className="text-center">
                <span className="text-white -mr-3">Didn't receive OTP?</span>
                <Button
                  type="link"
                  onClick={handleResend}
                  disabled={isResendDisabled}
                  className="text-darkMode-green text-sm sm:text-base underline" // Adjusted resend OTP text size for small screens
                >
                  Resend OTP {isResendDisabled && ` in ${timer}s`}
                </Button>
              </Form.Item>
            </Form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Verify;
